import { LazyAction, LazyImport, LazyModule } from 'owa-bundling';

export {
    clearAuthWindowInfo,
    setAuthWindowInfo,
    AuthWindowInfo,
} from './actions/helpers/AuthWindowInfo';
export { getAddableFileProviderInfo } from './utils/AddableFileProviderInfo';

export { default as AddableFileProviderInfo } from './utils/AddableFileProviderInfo';
export { default as AttachmentDataProvider } from 'owa-service/lib/contract/AttachmentDataProvider';
export {
    default as AttachmentDataProviderType,
} from 'owa-service/lib/contract/AttachmentDataProviderType';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "FilePickerAddFileProvider", webpackPrefetch: true */ './lazyIndex')
);

// Delay loaded actions
export const lazyAddFileProviderAfterAuthFinished = new LazyAction(
    lazyModule,
    m => m.addFileProviderAfterAuthFinished
);

if (typeof window !== 'undefined' && typeof window.Owa !== 'undefined') {
    /**
     * IMPORTANT: Do not change the name of the method attached to the window object (Owa.lazyAddFileProviderAfterAuthFinished).
     * Do not change the laziness of the assigned function, the assigned function (currently lazyAddFileProviderAfterAuthFinished) MUST be lazy.
     * This action is lazily invoked (via .importAndExecute) from HTML pages deployed at server for provider auth redirects. If the name of
     * "Owa.lazyAddFileProviderAfterAuthFinished" or the laziness of th function assigned to it are changed then a corresponding
     * change in those HTML pages (in owa-web-server repo) should also be changed and deployed along side it.
     */
    window.Owa.lazyAddFileProviderAfterAuthFinished = lazyAddFileProviderAfterAuthFinished;
}

// Delayed loaded imports
export const lazyGetAddableFileProviderInfo = new LazyImport(
    lazyModule,
    m => m.getAddableFileProviderInfo
);

export const lazyAddFileProvider = new LazyImport(lazyModule, m => m.addFileProvider);

export const lazyCreateAddableFileProviderInfo = new LazyImport(
    lazyModule,
    m => m.createAddableFileProviderInfo
);

export const lazyGetAuthRedirectPageUrl = new LazyImport(lazyModule, m => m.getAuthRedirectPageUrl);
